import React from 'react'
import AdditionalInfoConsentAndDocs from 'src/modules/Document/AdditionalInfo/ConsentAndDocs'

const AdditionalInfoConsentAndDocsPage = () => {
  return <AdditionalInfoConsentAndDocs />
}
export default AdditionalInfoConsentAndDocsPage
